import { UniformImage } from "./image";
export type { ImageProps } from "./image";

export default UniformImage;
